import { CustomCheckBox } from 'components/input';
import React, { useEffect, useState } from 'react';
import { IStyle } from 'Styles';
import { DropsCheckboxStateType, WellInfoAllSortDataType } from '../Contants';
import SortSelector from './SortSelector';

export interface WellInfoHeaderBarProps {
  dropsCheckboxState: DropsCheckboxStateType;
  wellInfoAllSortData: WellInfoAllSortDataType;
  totalDrops: number;
  setWellInfoAllSortData: React.Dispatch<React.SetStateAction<any>>;
  changeSorting: (number) => void;
  toggleDrops: (number) => void;
}

const WellInfoHeaderBar = (props: WellInfoHeaderBarProps) => {
  const {
    dropsCheckboxState,
    wellInfoAllSortData,
    totalDrops,
    setWellInfoAllSortData,
    changeSorting,
    toggleDrops,
  } = props;
  const [currentSortNumber, setCurrentSortNumber] = useState(-1);

  useEffect(() => {
    currentSortNumber > -1 && changeSorting(currentSortNumber);
  }, [currentSortNumber]);

  const onChangeSortByValue = (
    sortDropDownNumber: number,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setWellInfoAllSortData((prevState: WellInfoAllSortDataType) => {
      const updatedState = { ...prevState };

      updatedState[sortDropDownNumber] = {
        ...updatedState[sortDropDownNumber],
        selectedValue: e.target.value,
      };

      for (let i = sortDropDownNumber + 1; i <= sortDropDownNumber + 2 && i < 3; i++) {
        updatedState[i] = {
          ...updatedState[i],
          selectedValue: 'select',
        };
      }

      return updatedState;
    });
    setCurrentSortNumber(sortDropDownNumber);
  };

  const renderSortSelector = () => {
    return (
      <>
        {[0, 1, 2].map((value: number) => (
          <SortSelector 
            key={`fdSelect${value}`}
            sortByValue={wellInfoAllSortData[value].selectedValue}
            sortOrder={wellInfoAllSortData[value].sortOrder}
            onChange={(e) => onChangeSortByValue(value, e)}
            changeSorting={() => changeSorting(value)}
            disabled={value === 2 && window?.location?.pathname.includes('/screen')}
          />
        ))}
      </>
    );
  };

  const renderDrops = () => {
    return Array.from({ length: totalDrops }, (_, index) => (
      <CustomCheckBox id='exp-finddrop-wellinfoheaderbar-drops-chechkbox'
        key={`fdDrop${index}`}
        onChange={() => toggleDrops(index)}
        label={`Drop ${index + 1}`}
        checked={dropsCheckboxState[index]}
        mainContainerStyle={
          index == 3 ? { ...styles.dropLabel, marginLeft: '13%' } : styles.dropLabel
        }
        labelStyle={{ fontFamily: 'Arial', fontWeight: 400, marginLeft: '0.75rem' }}
      />
    ));
  };

  return (
    <div id='exp-finddrop-wellinfoheaderbar-maintitle' style={styles.mainTitleContent}>
      <div id='exp-finddrop-wellinfoheaderbar-sorttitle' style={styles.sortContent}>
        <span id='exp-finddrop-wellinfoheaderbar-subtitle' style={styles.subTitleText}>{`Sort By`}</span>
        {renderSortSelector()}
      </div>
      {!window?.location?.pathname.includes('/screen') && (
        <div id='exp-finddrop-wellinfoheaderbar-dropcontent' style={styles.dropContent}>
          <div id='exp-finddrop-wellinfoheaderbar-droptoggle' style={styles.dropToggle}>
            <div id='exp-finddrop-wellinfoheaderbar-drop' style={styles.drop}>{`Drop`}</div>
            {renderDrops()}
          </div>
        </div>
      )}
    </div>
  );
};

const styles: IStyle = {
  mainTitleContent: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '2%',
  },
  sortContent: {
    marginTop: '1%',
    marginLeft: '10px',
  },
  dropContent: {
    marginTop: '3%',
    marginLeft: '10px',
  },
  subTitleText: {
    marginRight: '2%',
    marginTop: '4px',
    float: 'left',
    fontSize: '0.9rem',
  },
  drop: {
    marginRight: '2%',
    fontSize: '0.9rem',
  },
  dropToggle: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  dropLabel: {
    marginLeft: '4%',
  },
};

export default WellInfoHeaderBar;
